import { ReactElement } from 'react';

import { PatientGroup, PatientGroupQuery } from '@dreryk/egabinet-patient-frontend-api';

import { paginations } from '@dreryk/command-query-ws-client';
import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { Message, MessageType } from '@dreryk/react-components';

import { filtersPanelTranslationKeys } from '../../translations';

type PatientFilterPanelLoaderChildrenRenderProps = {
   patientGroups: PatientGroup[];
};

type PatientFilterPanelLoaderProps = {
   children: (renderProps: PatientFilterPanelLoaderChildrenRenderProps) => ReactElement;
};

export const PatientFilterPanelLoader = (props: PatientFilterPanelLoaderProps): ReactElement | null => {
   const {
      data: patientGroups,
      loading: patientGroupsLoading,
      error: patientGroupsError,
   } = useCqrsSearch<PatientGroup>(() => new PatientGroupQuery(), paginations.all());

   if (patientGroupsLoading) {
      return null;
   }

   if (patientGroupsError) {
      return (
         <Message
            testId={'failedToFetchData'}
            label={filtersPanelTranslationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({ patientGroups: patientGroups });
};
